import type { SiteConfig } from '@/types'
import { getOrigin } from '@/lib/window'

export const siteConfig: SiteConfig = {
    name: 'Modulo Admin',
    description: 'Internal Azwedo admin for managing the Webflow components, categories and tags of Modulo.',
    url: getOrigin()
}
